// extracted by mini-css-extract-plugin
export default {"loginContainer":"LoginForm_loginContainer__QXB1f","loginForm":"LoginForm_loginForm__RJ9hq","forgotPassword":"LoginForm_forgotPassword__y1PVM"};